module.exports = new __parcel__URL__("edit-ticket-with-background-light.78ada054.svg").toString();